import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import { Skeleton } from "@mui/material";
/**
 * ContentSkeleton
 *
 * نمایش اسکلتی (Skeleton) برای بخش‌های در حال بارگذاری محتوا.
 *
 * ویژگی‌ها:
 * - استفاده از کامپوننت MUI Skeleton برای شبیه‌سازی محتوا در حال بارگذاری
 * - طراحی واکنش‌گرا با استفاده از StackKit و BoxKit
 * - شامل هدر با اسکلتی برای عنوان و دکمه و لیستی از ردیف‌های اسکلتی برای جدول یا محتوا
 *
 * @returns JSX.Element
 */

const ContentSkeleton = () => {
  return (
    <StackKit
      direction={"column"}
      sx={{
        background: "linear-gradient(112.89deg, rgba(0, 0, 0, 0.1) -15.04%, rgba(134, 134, 134, 0.235528) 30.35%, rgba(255, 165, 0, 0.26) 72.13%, rgba(0, 0, 0, 0.5) 118.94%)",
        minHeight: "828px",
        width: "100%",
        borderRadius: "8px",
      }}
    >
      <StackKit direction={"row"} sx={{width: "100%",justifyContent: "space-between",padding: "10px 20px",height: "100px",alignItems: "center",}}>
        <BoxKit>
          <Skeleton sx={{ width: "100px", height: "30px" }} />
        </BoxKit>
        <StackKit direction={"row"} sx={{ padding: "0 20px", justifyContent: "space-between" }} gap={3}>
          <BoxKit sx={{ width: "372px", height: "38px" }} gap={3}>
            <Skeleton sx={{ width: "200px", height: "50px" }} />
          </BoxKit>
          <CustomButton sx={{ padding: "8px 42px" }}>
            <Skeleton sx={{ width: "50px", height: "100%" }} />
          </CustomButton>
        </StackKit>
      </StackKit>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => {
        return (
          <StackKit direction={"row"} sx={{ width: "100%", padding: "10px 20px" }} justifyContent={"space-between"}>
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
            <Skeleton sx={{ width: "100px", height: "30px" }} />
          </StackKit>
        );
      })}
    </StackKit>
  );
};

export default ContentSkeleton;
